import Hades from '@adoratorio/hades';
import engine from './engine';
import store from '@/store';

const scroll = {
  ref: null,

  init(DOMElement, DOMContainer) {
    scroll.ref = new Hades({
      viewport: DOMElement,
      container: DOMContainer,
      easing: {
        duration: 1000,
        mode: Hades.EASING.CUBIC,
      },
      renderByPixel: false,
      renderScroll: false,
      aion: engine,
      scrollbar: null,
      autoBoundries: false,
      smoothDirectionChange: true,
    });
  },

  setBoundries(DOMElement, offset = 0) {
    scroll.ref.boundries = Hades.createBoundries(
      0,
      0,
      0,
      (DOMElement.getBoundingClientRect().height - window.innerHeight) + offset,
    );
  },

  checkIsScrolled(threshold = 10) {
    if (scroll.ref.amount.y > threshold && !store.state.page.scrolled) {
      store.commit('SET_PAGE_SCROLLED', true);
    } else if (scroll.ref.amount.y <= threshold && store.state.page.scrolled) {
      store.commit('SET_PAGE_SCROLLED', false);
    }
  },
};

export default scroll;
